/* eslint-disable react/prop-types */
import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CSpinner,
} from '@coreui/react'

const MemberExclusionModal = ({
  visible,
  onClose,
  onConfirm,
  memberName,
  isLoading,
  cilWarning,
}) => {
  return (
    <CModal visible={visible} onClose={onClose} alignment="center">
      <CModalHeader className="border-bottom-0">
        <CModalTitle className="text-danger">Confirmer l'exclusion</CModalTitle>
      </CModalHeader>
      <CModalBody className="text-center py-4">
        <div className="mb-4">
          <CIcon icon={cilWarning} className="h-12 w-12 text-danger mx-auto" />
        </div>
        <h3 className="mb-4">Êtes-vous sûr de vouloir exclure {memberName} ?</h3>
        <p className="text-muted">
          Cette action est irréversible. Le membre sera définitivement supprimé et perdra tout accès
          à la plateforme.
        </p>
      </CModalBody>
      <CModalFooter className="border-top-0">
        <CButton color="secondary" onClick={onClose} disabled={isLoading}>
          Annuler
        </CButton>
        <CButton color="danger" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? (
            <>
              <CSpinner size="sm" className="me-2" />
              Exclusion en cours...
            </>
          ) : (
            "Confirmer l'exclusion"
          )}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default MemberExclusionModal
